<div
  *ngIf="checkList?.length !== 0"
  class="checkbox-block">
  <div
    (click)="checkAll()"
    class="checkbox-block__head">
    <span
      [class.unchecked]="stateCheckAll === 'unchecked'"
      [class.checked]="stateCheckAll === 'checked'"
      [class.part]="stateCheckAll === 'part'"
      class="checkbox-block__head-checkbox"></span>
    <p class="checkbox-block__head-name">{{title | translate}}</p>
  </div>
  <ul class="checkbox-block__list">
    <li
    *ngFor="let item of checkList ?? []"
      class="checkbox-block__list-item">
      <app-checkbox-item
        (changeItem)="changeItem(item)"
        [item]="item">
      </app-checkbox-item>
    </li>
  </ul>
</div>
